/**
 * @copyright Copyright (c) 2015, Pacific Biosciences of California, Inc.
 * @author <a href="mailto:bskinner@pacificbiosciences.com">Brian Skinner</a>
 */

import {Frame} from "../frames/frame"

export interface IFacet {
    frame: Frame
    defaultColumns: Array<string>
    displayProperties?: Array<string>
    additionalColumns?: Array<string>
    multiSelect?: boolean
    initialSort?: Function
}

export class Facet implements IFacet {
    public frame: Frame
    public displayProperties: Array<string>
    public defaultColumns: Array<string>
    public additionalColumns: Array<string>
    public multiSelect: boolean
    public initialSort: Function | undefined

    constructor(facet: IFacet) {
        this.frame = facet.frame
        this.defaultColumns = facet.defaultColumns
        this.additionalColumns = facet.additionalColumns || []
        this.displayProperties = facet.displayProperties || []
        this.multiSelect = Boolean(facet.multiSelect)
        this.initialSort = facet.initialSort
    }
}
